"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _lcHttp = _interopRequireDefault(require("lc-http"));
require("@ui-propulsion/core/styles.scss");
var _Page = _interopRequireDefault(require("./components/Page"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var EmailVerification = function EmailVerification(props) {
  var confirmationCode = props.confirmationCode,
    linkExpired = props.linkExpired,
    market = props.market;
  var basePath = market === 'PATIENT_SOLUTIONS' ? '/patientsolutions/app' : '';
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    emailSent = _useState2[0],
    setEmailSent = _useState2[1];
  var resendEmail = function resendEmail() {
    var url = "".concat(basePath, "/resend-email");
    var payload = {
      confirmationCode: confirmationCode
    };
    _lcHttp.default.post(url, payload).then(function (response) {
      var _response$data = response.data,
        data = _response$data === void 0 ? {} : _response$data;
      if (data.error) {
        window.location.assign("".concat(basePath, "/error"));
      }
      if (data.emailSent) {
        setEmailSent(data.emailSent);
      }
    }).catch(function () {
      window.location.assign("".concat(basePath, "/error"));
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "page__container"
  }, /*#__PURE__*/_react.default.createElement(_Page.default, {
    linkExpired: linkExpired,
    confirmationCode: confirmationCode,
    emailSent: emailSent,
    resendEmail: resendEmail,
    market: market
  }));
};
EmailVerification.propTypes = {
  confirmationCode: _propTypes.string.isRequired,
  linkExpired: _propTypes.bool.isRequired,
  market: _propTypes.string.isRequired
};
var _default = EmailVerification;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/@pf-loan-funnel/email-verification/lib/styles.scss');